import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserService } from '../../../../../services/user.service';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface State {
}

const defaultState: State = {};

@Injectable()
export class UserExperienceDialogStore extends ComponentStoreFactory<State> {
    constructor() {
        super(defaultState, inject(Store), inject(UserService));
    }
}
